<script setup>
import ReleaseHoldbacksComponent from "@/Components/HoldBacks/ReleaseHoldbacksComponent.vue";
import {Permissions} from "@/Utils/Permissions";
import {useRoute} from "vue-router";

const route = useRoute();
</script>

<template>
  <v-row>
    <v-col cols="12">
      <ReleaseHoldbacksComponent v-if="Permissions.checkPermissions(['holdbacks.release'])" :payPeriodId="route.params.payPeriodId"/>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>